import React from 'react'
import { Typography } from '@mui/material'
import Header from 'redesign/components/organisms/Header'
import SubheaderTabs from './subheader-tabs'
import type { TabsHeaderProps } from './types'

const TabsHeader: React.FC<TabsHeaderProps> = ({ title, startContent }) => (
  <Header
    startContent={startContent}
    middleContent={<Typography variant="subtitle1">{title}</Typography>}
    subheader={<SubheaderTabs />}
  />
)

export default TabsHeader
